<template>
  <v-container fluid fill-height class="bg-texture">
    <support-chat-component :api-url="'https://ai-bos.co/mcp-tickets'" />
    <!-- Snackbar para notificaciones -->
    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :timeout="snackbar.timeout"
      top
    >
      <span class="subtitle-1">{{ snackbar.text }}</span>
      <template v-slot:action="{ attrs }">
        <v-btn
          text
          v-bind="attrs"
          @click="snackbar.show = false"
          class="white--text"
          small
        >
          Cerrar
        </v-btn>
      </template>
    </v-snackbar>

    <!-- Indicador de fecha de vencimiento (cuando hay datos cargados) -->
    <div v-if="hasStoreData && storeData.dueDate" class="account-info-chip">
      <v-icon small color="amber" class="mr-1">mdi-clock-outline</v-icon>
      <span>Vence: {{ formatDueDate(storeData.dueDate) }}</span>
    </div>

    <v-layout align-center justify-center>
      <v-flex>
        <v-row class="fill-height ma-0">
          <v-col cols="12" md="6" class="d-flex align-center justify-center">
            <div class="carousel-content pa-6">
              <h2 class="text-h3 font-weight-bold blue-grey--text mb-2">
                {{ storeData.store_name || "Punto de Venta Inteligente" }}
              </h2>
              <p class="text-h6 blue-grey--text">
                {{
                  storeData.store_business_id
                    ? `NIT: ${storeData.store_business_id}`
                    : "Control total de tu inventario con alertas automáticas y sugerencias de reabastecimiento basadas en IA."
                }}
              </p>
              <p class="text-h6 blue-grey--text">
                {{
                  storeData.store_category ||
                  "Administra tu restaurante con nuestra solución completa diseñada para maximizar la eficiencia operativa."
                }}
              </p>
              <p class="text-h6 blue-grey--text">
                {{
                  storeData.store_city
                    ? `${storeData.store_city} - ${storeData.store_address}`
                    : "Visualiza el rendimiento de tu negocio con reportes detallados y gráficos que muestran tendencias importantes."
                }}
              </p>
            </div>
          </v-col>
          <v-col
            cols="12"
            md="6"
            class="d-flex align-center justify-center position-relative"
          >
            <v-img
              contain
              class="carousel-image"
              :src="storeData.store_logo || require('../assets/registradora.png')"
              :alt="storeData.store_name || 'Punto de Venta'"
            ></v-img>
            <div class="image-overlay"></div>
          </v-col>
        </v-row>
      </v-flex>
    </v-layout>

    <v-bottom-navigation
      app
      color="success darken-2"
      background-color="rgba(0, 0, 0, 0.7)"
      dark
      class="bottom-nav-container"
    >
      <v-btn text class="d-none d-sm-block">
        <span>{{ storeData.PartyName || brandConfig.title }}</span>
        <v-icon>{{ brandConfig.icon }}</v-icon>
      </v-btn>

      <v-spacer></v-spacer>
      <Register />

      <v-btn text href="/terminos">
        <span class="d-none d-sm-block">Términos</span>
        <v-icon>mdi-file-document-outline</v-icon>
      </v-btn>

      <v-btn text href="/privacidad">
        <span class="d-none d-sm-block">Privacidad</span>
        <v-icon>mdi-shield-account-outline</v-icon>
      </v-btn>

      <v-btn text href="mailto:soporte@ai-pos.co">
        <span class="d-none d-sm-block">Soporte</span>
        <v-icon>mdi-help-circle-outline</v-icon>
      </v-btn>
    </v-bottom-navigation>
    <!-- Bottom Navigator con altura ajustada -->

    <!-- Botón flotante de login (esquina superior derecha) -->
    <v-btn
      fab
      color="success darken-2"
      absolute
      top
      right
      style="z-index: 10; top: 20px; right: 20px"
      @click="showLoginDialog = true"
      elevation="8"
    >
      <v-icon>mdi-login</v-icon>
    </v-btn>

    <!-- Diálogo de login -->
    <v-dialog
      v-model="showLoginDialog"
      persistent
      max-width="500"
      content-class="login-dialog"
    >
      <v-card class="login-card">
        <v-card-title class="pa-2">
          <v-toolbar flat dark class="transparent">
            <v-toolbar-title class="white--text font-weight-bold">
              Iniciar Sesión
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="showLoginDialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
        </v-card-title>

        <v-card-text class="px-4 pt-4">
          <v-form
            ref="form"
            v-model="valid"
            @submit.prevent="login"
            lazy-validation
            class="login-form"
          >
            <v-text-field
              v-model="credential.store"
              label="Tienda"
              :rules="storeRules"
              id="store"
              outlined
              required
              type="number"
              dense
              dark
              color="amber"
              class="restaurant-field"
              autocomplete="off"
              hide-details="auto"
            ></v-text-field>

            <v-text-field
              v-model="credential.user_email"
              label="Correo electrónico"
              outlined
              required
              dense
              type="email"
              dark
              color="amber"
              class="restaurant-field"
              autocomplete="email"
              prepend-inner-icon="mdi-email-outline"
              hide-details="auto"
            ></v-text-field>

            <v-text-field
              v-model="credential.user_password"
              label="Contraseña"
              :rules="passwordRules"
              outlined
              required
              dense
              dark
              color="amber"
              class="restaurant-field"
              autocomplete="current-password"
              :type="showPassword ? 'text' : 'password'"
              prepend-inner-icon="mdi-lock-outline"
              :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
              @click:append="showPassword = !showPassword"
              hide-details="auto"
            ></v-text-field>

            <div class="d-flex flex-wrap align-center justify-space-between my-2">
              <v-checkbox
                v-model="rememberMe"
                label="Recordarme"
                color="amber"
                dark
                hide-details
                class="mt-0"
                dense
              ></v-checkbox>

              <v-btn
                text
                x-small
                color="amber lighten-3"
                class="ml-auto"
                @click="forgotPassword"
              >
                ¿Olvidó su contraseña?
              </v-btn>
            </div>

            <v-btn
              :disabled="!valid || loading_status"
              :loading="loading_status"
              color="amber darken-2"
              type="submit"
              class="restaurant-button black--text mt-4"
              elevation="2"
              block
            >
              <v-icon left>mdi-login</v-icon>
              Ingresar
            </v-btn>
          </v-form>
        </v-card-text>

        <v-divider class="mx-4 mt-2"></v-divider>

        <v-card-actions class="px-4 py-3">
          <div class="d-flex align-center">
            <v-icon color="amber darken-3" class="mr-1" small>mdi-shield-check</v-icon>
            <span class="text-caption grey--text text--lighten-1"
              >Conexión segura SSL</span
            >
            <span class="mx-2 grey--text">•</span>
            <span class="text-caption grey--text text--lighten-1">V2</span>
            <span class="mx-2 grey--text">•</span>
            <span class="text-caption">
              <a href="mailto:soporte@ai-pos.co" class="amber--text text--lighten-3"
                >Soporte</a
              >
            </span>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { webserver } from "../services/webserver.js";
import createProfile from "../utils/createProfile.js";
import Register from "@/components/Register.vue";
import SupportChatComponent from "@/components/SupportChatComponent.vue";

export default {
  name: "Login",
  components: { Register, SupportChatComponent },
  props: {
    nextUrl: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      showFacialRecognition: false,
      showEnrollmentDialog: false,
      currentUserId: "1001",
      errors: [],
      valid: false,
      loading_status: false,
      showPassword: false,
      rememberMe: false,
      showLoginDialog: false,
      snackbar: {
        show: false,
        text: "",
        color: "error",
        timeout: 5000,
      },
      storeRules: [
        (v) => !!v || "Tienda es requerida",
        (v) =>
          (v && v.toString().length >= 9) || "La tienda debe tener al menos 9 dígitos",
        (v) => /^\d+$/.test(v) || "Solo se permiten números",
      ],
      emailRules: [
        (v) => !!v || "Email es requerido",
        (v) => /.+@.+\..+/.test(v) || "Email debe ser válido",
      ],
      passwordRules: [
        (v) => !!v || "Contraseña es requerida",
        (v) => (v && v.length >= 3) || "La contraseña debe tener al menos 3 caracteres",
      ],
      credential: {
        store: null,
        user_email: null,
        user_password: null,
      },
      profile: createProfile(),
      // Configuración predeterminada
      brandConfig: {
        icon: "mdi-silverware-fork-knife",
        title: "AI-Pos",
        subtitle: "Punto de venta Inteligente para Restaurantes",
      },
      // Mapeo de dominios a configuraciones
      domainConfigs: {
        "restaurant.ai-pos.co": {
          icon: "mdi-silverware-fork-knife",
          title: "AI-Pos",
          subtitle: "Punto de venta Inteligente para Restaurantes",
        },
        "tpv.ai-pos.co": {
          icon: "mdi-credit-card-outline",
          title: "TPV",
          subtitle: "Terminal Punto de Venta",
        },
        // Puedes agregar más configuraciones de dominios aquí
      },
      // Datos de la tienda (se llenará con datos guardados o del login)
      storeData: {
        store_name: "",
        store_category: "",
        store_address: "",
        store_city: "",
        store_logo: "",
        store_url: "",
        store_business_id: "",
        PartyName: "",
        PartyIdentification_Id: "",
        dueDate: "",
        status: "",
      },
    };
  },

  computed: {
    // Verificar si tenemos datos de tienda cargados
    hasStoreData() {
      return this.storeData && (this.storeData.store_name || this.storeData.PartyName);
    },
  },

  created() {
    // Verificar si hay credenciales y datos de tienda guardados
    this.checkSavedCredentials();

    // Cargar datos de tienda guardados
    this.loadSavedStoreData();

    // Detectar el dominio y configurar el branding correspondiente
    this.detectDomainAndSetBranding();
  },

  mounted() {
    this.$store.dispatch("setNavStatus", false);
    this.$store.dispatch("set_menu", false);
  },

  methods: {
    handleEnrollmentComplete(data) {
      console.log("Usuario registrado:", data);
      // Aquí puedes actualizar tu lista de usuarios, etc.
    },

    handleAccessGranted(data) {
      console.log("Acceso concedido:", data);
      // Aquí puedes redirigir al usuario, actualizar el estado, etc.
    },

    // Método para cargar datos de tienda guardados
    loadSavedStoreData() {
      try {
        // Intentar cargar los datos de la tienda del localStorage
        const savedStoreData = localStorage.getItem("ai_pos_store_data");
        if (savedStoreData) {
          this.storeData = JSON.parse(savedStoreData);
          //console.log("Datos de tienda cargados:", this.storeData);
        }
      } catch (error) {
        console.error("Error al cargar datos de tienda:", error);
      }
    },

    // Método para verificar credenciales guardadas
    checkSavedCredentials() {
      const savedStore = localStorage.getItem("ai_pos_store");
      const savedEmail = localStorage.getItem("ai_pos_email");

      if (savedStore && savedEmail) {
        this.credential.store = savedStore;
        this.credential.user_email = savedEmail;
        this.rememberMe = true;
      }
    },

    // Método para guardar los datos de la tienda en localStorage
    saveStoreData(storeData) {
      try {
        if (storeData && typeof storeData === "object") {
          // Guardar los datos de la tienda como JSON
          localStorage.setItem("ai_pos_store_data", JSON.stringify(storeData));
          //console.log("Datos de tienda guardados correctamente");
        }
      } catch (error) {
        console.error("Error al guardar datos de tienda:", error);
      }
    },

    // Método para guardar credenciales
    saveCredentials() {
      if (this.rememberMe) {
        localStorage.setItem("ai_pos_store", this.credential.store);
        localStorage.setItem("ai_pos_email", this.credential.user_email);
      } else {
        localStorage.removeItem("ai_pos_store");
        localStorage.removeItem("ai_pos_email");
      }
    },

    // Método para formatear la fecha de vencimiento
    formatDueDate(dateString) {
      try {
        if (!dateString) return "";

        const date = new Date(dateString);
        const today = new Date();

        // Calcular días restantes
        const diffTime = date.getTime() - today.getTime();
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

        // Formatear la fecha
        const day = date.getDate().toString().padStart(2, "0");
        const month = (date.getMonth() + 1).toString().padStart(2, "0");
        const year = date.getFullYear();

        // Si faltan menos de 30 días, mostrar los días restantes
        if (diffDays <= 30 && diffDays > 0) {
          return `${day}/${month}/${year} (${diffDays} días)`;
        }

        // Si ya venció
        if (diffDays <= 0) {
          return `${day}/${month}/${year} (Vencido)`;
        }

        return `${day}/${month}/${year}`;
      } catch (error) {
        console.error("Error al formatear fecha:", error);
        return dateString || "";
      }
    },

    // Método para manejar olvido de contraseña
    forgotPassword() {
      // Implementar lógica de recuperación de contraseña
      this.showNotification(
        "Función de recuperación de contraseña no implementada",
        "info"
      );
    },

    // Método para detectar el dominio y establecer el branding correspondiente
    detectDomainAndSetBranding() {
      // Obtener el hostname actual
      const currentHostname = window.location.hostname;

      // Buscar configuración para el dominio actual
      if (this.domainConfigs[currentHostname]) {
        this.brandConfig = this.domainConfigs[currentHostname];
      } else {
        // Si no hay configuración específica para este dominio, usar la configuración predeterminada
        // que ya está establecida en data()
        //console.log("Usando configuración de marca predeterminada");
      }
    },

    validate() {
      return this.$refs.form ? this.$refs.form.validate() : false;
    },

    showNotification(message, color = "error") {
      this.snackbar.text = message;
      this.snackbar.color = color;
      this.snackbar.show = true;
    },

    handleLoginError(message) {
      this.loading_status = false;

      if (this.$refs.form) {
        this.$refs.form.reset();
      }

      this.credential = {
        store: null,
        user_email: null,
        user_password: null,
      };

      this.showNotification(message);

      this.$nextTick(() => {
        this.valid = false;
        const storeInput = document.getElementById("store");
        if (storeInput) {
          storeInput.focus();
        }
      });
    },

    validateLoginResponse(data) {
      // Validar data
      if (!data || typeof data !== "object") {
        return { error: true, message: "Respuesta del servidor inválida" };
      }

      // Validar estado y fecha de vencimiento
      if (!data.store?.dueDate || !data.store?.status) {
        return { error: true, message: "Información de cuenta incompleta" };
      }

      // Validar vencimiento y estado
      const validationResult = this.validateDueDate(
        data.store.dueDate,
        data.store.status
      );

      if (validationResult.error) {
        return validationResult;
      }

      // Validar profile
      if (!data.profile) {
        return { error: true, message: "Datos de perfil no encontrados" };
      }

      // Solo validar campos críticos del profile
      const criticalProfileFields = [
        "store_id",
        "user_email",
        "user_name",
        "user_access",
      ];

      const missingProfileFields = criticalProfileFields.filter(
        (field) => !data.profile[field]
      );
      if (missingProfileFields.length > 0) {
        return {
          error: true,
          message: `Datos de perfil incompletos: ${missingProfileFields.join(", ")}`,
        };
      }

      // Validar seller
      if (!data.seller) {
        return { error: true, message: "Datos del vendedor no encontrados" };
      }

      // Solo validar campos críticos del seller
      const criticalSellerFields = ["PartyIdentification", "store_code", "PartyName"];

      const missingSellerFields = criticalSellerFields.filter(
        (field) => !data.seller[field]
      );
      if (missingSellerFields.length > 0) {
        return {
          error: true,
          message: `Datos del vendedor incompletos: ${missingSellerFields.join(", ")}`,
        };
      }

      // Validar store
      if (!data.store) {
        return { error: true, message: "Datos de la tienda no encontrados" };
      }

      // Solo validar campos críticos de la tienda
      const criticalStoreFields = ["store_id", "store_name", "store_category"];

      const missingStoreFields = criticalStoreFields.filter(
        (field) => !data.store[field]
      );
      if (missingStoreFields.length > 0) {
        return {
          error: true,
          message: `Datos de la tienda incompletos: ${missingStoreFields.join(", ")}`,
        };
      }

      // Validar token
      if (!data.token) {
        return { error: true, message: "Token de sesión inválido" };
      }

      // Validar que settings sea un array (puede estar vacío)
      if (!Array.isArray(data.settings)) {
        return { error: true, message: "Configuraciones inválidas" };
      }

      return { error: false, message: "Validación exitosa" };
    },

    validateDueDate(dueDate, status) {
      if (status == "Hold") {
        return { error: true, message: "La cuenta no está activa" };
      }

      const today = new Date();
      const expirationDate = new Date(dueDate);

      // Si la fecha de vencimiento ya pasó
      if (today > expirationDate) {
        return {
          error: true,
          message:
            "Su cuenta ha vencido. Por favor, contacte al administrador para renovar su suscripción.",
        };
      }

      // Calcular días restantes
      const diffTime = expirationDate.getTime() - today.getTime();
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

      // Si quedan 5 días o menos, pero la cuenta aún no ha vencido
      if (diffDays <= 5 && diffDays > 0) {
        return {
          warning: true,
          daysLeft: diffDays,
          message: `Su cuenta vencerá en ${diffDays} día${
            diffDays === 1 ? "" : "s"
          }. Por favor, renueve su suscripción.`,
        };
      }

      return { error: false, warning: false };
    },

    login(e) {
      e.preventDefault();

      if (!this.validate()) {
        this.showNotification("Por favor, complete todos los campos correctamente");
        return;
      }

      this.loading_status = true;

      try {
        var md5 = require("md5");
        const passwordHash = md5(this.credential.user_password);

        // Crear una copia de las credenciales para evitar modificar directamente
        const loginCredentials = {
          ...this.credential,
          user_password: passwordHash,
        };

        const self = this;

        webserver("login", loginCredentials, (data) => {
          try {
            if (!data) {
              self.handleLoginError("Error de conexión con el servidor");
              return;
            }

            if (data.error) {
              self.handleLoginError(data.message || "Error en las credenciales");
              return;
            }

            const validationResult = self.validateLoginResponse(data);
            if (validationResult.error) {
              self.handleLoginError(validationResult.message);
              return;
            }

            // Validar vencimiento
            const dueDateValidation = self.validateDueDate(
              data.store.dueDate,
              data.store.status
            );
            if (dueDateValidation.error) {
              self.handleLoginError(dueDateValidation.message);
              return;
            }

            const proceedWithLogin = () => {
              try {
                // Guardar credenciales si la opción está activada
                self.saveCredentials();

                // Guardar los datos de la tienda
                self.storeData = {
                  ...data.store,
                  PartyName: data.seller?.PartyName || "",
                  PartyIdentification_Id: data.seller?.PartyIdentification_Id || "",
                };

                // Actualizar los datos de la tienda en localStorage
                self.saveStoreData(self.storeData);

                self.profile.name = data.profile.user_name;
                self.profile.email = data.profile.user_email;
                self.profile.token = data.profile.token;
                self.profile.picture = data.profile.user_photo || "";
                self.profile.socialName = "SW67";
                self.profile.user_access = data.profile.user_access;

                self.$store.dispatch("setProfile", self.profile);
                self.$store.dispatch("setSeller", data.seller);

                window.token = data.token;
                window.profile = data.profile;
                window.curvas = data.curvas || [];
                window.store = data.store;
                window.seller = data.seller;

                // Optimización: usar reduce para agrupar configuraciones
                window.settings = data.settings.reduce((r, a) => {
                  r[a.tabla] = r[a.tabla] || [];
                  r[a.tabla].push(a);
                  return r;
                }, Object.create(null));

                self.$store.dispatch("setNavStatus", true);
                self.$store.dispatch("set_menu", true);

                self.showLoginDialog = false;
                self.showNotification("Inicio de sesión exitoso", "success");

                console.log("Redirigiendo a la página principal...", window.store);

                // Delay before redirect
                setTimeout(() => {
                  if (self.nextUrl) {
                    self.$router.push(self.nextUrl);
                  } else {
                    switch (window.store.status) {
                      case "Register":
                        self.$router.push("/register");
                        break;
                      case "PLU":
                        self.$router.push("/plu");
                        break;
                      case "Active":
                        self.$router.push("/plu");
                        break;
                      case "EAN":
                        self.$router.push("/InvoiceE");
                        break;
                      default:
                        self.$router.push("/register"); // Fallback to comanda
                    }
                  }
                }, 1000);
              } catch (error) {
                console.error("Error procesando datos:", error);
                self.handleLoginError("Error procesando la respuesta del servidor");
              }
            };

            // Si hay advertencia, mostrar y esperar antes de continuar
            if (dueDateValidation.warning) {
              self.showNotification(dueDateValidation.message, "warning");
              setTimeout(proceedWithLogin, 5000);
            } else {
              proceedWithLogin();
            }
          } catch (error) {
            console.error("Error en proceso de login:", error);
            self.handleLoginError("Error en el proceso de inicio de sesión");
          }
        });
      } catch (error) {
        console.error("Error general:", error);
        this.handleLoginError("Error general en el proceso");
      }
    },
  },
};
</script>

<style scoped>
.material-icons {
  font-feature-settings: "liga";
  -webkit-font-smoothing: antialiased;
}

.main-container {
  min-height: 100vh;
  overflow: hidden;
  background-color: #121212;
  position: relative;
}

/* Estilos para el carrusel */
.carousel-container {
  position: relative;
  z-index: 1;
  box-shadow: inset 0 0 200px rgba(0, 0, 0, 0.1);
}

.carousel-container::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(0, 0, 0, 0.3) 0%, rgba(0, 0, 0, 0.1) 100%);
  z-index: 1;
  pointer-events: none;
}

.carousel-content {
  position: relative;
  z-index: 2;
  max-width: 550px;
}

.carousel-content h2 {
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.carousel-content p {
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.5);
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}

.carousel-image {
  position: relative;
  z-index: 2;

  transition: all 0.5s ease-out;
  max-height: 70vh;
  object-fit: contain;
}

.image-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: radial-gradient(circle at center, transparent 50%, rgba(0, 0, 0, 0.4) 100%);
  z-index: 3;
  pointer-events: none;
}

/* Botón flotante de login */
.v-btn.ma-6 {
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.3), 0 0 15px rgba(255, 183, 0, 0.3);
  z-index: 10;
}

.v-btn.ma-6:hover {
  transform: translateY(5px);
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.4), 0 0 20px rgba(255, 183, 0, 0.4);
}

.v-btn.ma-6::before {
  content: "";
  position: absolute;
  top: -10px;
  left: -10px;
  right: -10px;
  bottom: -10px;
  border-radius: 50%;
  background: rgba(255, 183, 0, 0.1);
  z-index: -1;
  animation: pulse-ring 2s infinite;
}

@keyframes pulse-ring {
  0% {
    transform: scale(0.8);
    opacity: 0.3;
  }
  80%,
  100% {
    transform: scale(1.5);
    opacity: 0;
  }
}

/* Bottom Navigator */
.bottom-nav-container {
  backdrop-filter: blur(10px);
  border-top: 1px solid rgba(255, 183, 0, 0.2);
  z-index: 5;
}

.bottom-nav-container .v-btn {
  color: rgba(255, 255, 255, 0.8);
  transition: all 0.3s ease;
}

.bottom-nav-container .v-btn:hover {
  color: #ffb300;
}

/* Diálogo de login */
.login-dialog {
  background: transparent;
}

.login-card {
  background: linear-gradient(135deg, #1a1a1a 0%, #3f3e3e 100%);
  border-radius: 10px;
  overflow: hidden;
  border: 1px solid rgba(255, 183, 0, 0.2);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.5), 0 0 0 1px rgba(255, 183, 0, 0.1),
    0 0 20px rgba(255, 183, 0, 0.2);
}

.restaurant-field {
  border-radius: 4px;
  margin-bottom: 16px !important;
}

.restaurant-field >>> .v-input__slot {
  background-color: rgba(30, 30, 30, 0.7) !important;
  border: 1px solid rgba(255, 179, 0, 0.2) !important;
  transition: all 0.2s ease;
}

.restaurant-field >>> .v-input__slot:hover {
  border-color: rgba(255, 179, 0, 0.4) !important;
  box-shadow: 0 0 5px rgba(255, 179, 0, 0.1);
}

.restaurant-field >>> .v-input__slot--focused,
.restaurant-field >>> .v-input__slot:focus-within {
  border-color: #ffb300 !important;
  box-shadow: 0 0 8px rgba(255, 179, 0, 0.2);
}

.restaurant-field >>> .v-label {
  color: rgba(255, 255, 255, 0.7) !important;
  font-size: 14px;
  transition: all 0.2s ease;
}

.restaurant-field >>> .v-input--is-focused .v-label {
  color: rgba(255, 179, 0, 0.9) !important;
}

/* Efectos para los datos personalizados de la tienda */
.carousel-content h2,
.carousel-content p {
  transition: all 0.3s ease;
}

.carousel-content h2:not(:empty) {
  position: relative;
}

.carousel-content h2:not(:empty)::after {
  content: "";
  position: absolute;
  bottom: -5px;
  left: 0;
  width: 50px;
  height: 3px;
  background-color: #ffb700;
  transition: width 0.3s ease;
}

.carousel-content:hover h2:not(:empty)::after {
  width: 100px;
}

/* Reducir el espacio entre campos */
.login-form .v-text-field {
  margin-top: 8px !important;
  margin-bottom: 8px !important;
}

.restaurant-button {
  border-radius: 6px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease;
  text-transform: none;
  letter-spacing: 0.5px;
  font-weight: 500;
  font-size: 16px;
}

.restaurant-button:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);
  transform: translateY(-2px);
}

.restaurant-button:active {
  transform: translateY(0);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

/* Animaciones para elementos del carrusel */
@keyframes fadeSlideUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeSlideIn {
  from {
    opacity: 0;
    transform: translateX(-30px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

.v-carousel__item--active .carousel-content h2 {
  animation: fadeSlideIn 0.8s ease-out both;
}

.v-carousel__item--active .carousel-content p {
  animation: fadeSlideIn 0.8s ease-out 0.2s both;
}

.v-carousel__item--active .carousel-content .v-btn {
  animation: fadeSlideUp 0.8s ease-out 0.4s both;
}

.v-carousel__item--active .carousel-image {
  animation: fadeSlideUp 1s ease-out 0.3s both;
}

/* Animación para el botón de login */
@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(255, 179, 0, 0.4);
  }
  70% {
    box-shadow: 0 0 0 5px rgba(255, 179, 0, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(255, 179, 0, 0);
  }
}

.restaurant-button:not(:disabled):not(.v-btn--loading) {
  animation: pulse 2s infinite;
}

/* Estilos para mostrar información de cuenta */
.account-info-chip {
  position: absolute;
  top: 20px;
  left: 20px;
  z-index: 10;
  background: rgba(0, 0, 0, 0.7);
  border: 1px solid rgba(255, 183, 0, 0.3);
  color: white;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 12px;
  backdrop-filter: blur(5px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  transition: all 0.3s ease;
}

.account-info-chip:hover {
  background: rgba(255, 183, 0, 0.2);
}

/* Estilo para cuando hay datos de la tienda cargados */
.store-loaded .carousel-content {
  transform: scale(1.02);
  transition: transform 0.5s ease;
}

.store-loaded .carousel-image {
  box-shadow: 0 20px 40px rgba(255, 183, 0, 0.1), 0 10px 20px rgba(0, 0, 0, 0.3);
}

/* Ajustes responsivos */
@media (max-width: 959px) {
  .carousel-content {
    text-align: center;
    padding: 0 16px;
  }

  /* Ajustes para el bottom navigator en dispositivos móviles */
  .bottom-nav-container .v-btn {
    min-width: auto;
    padding: 0 8px;
  }
}

@media (max-width: 599px) {
  .carousel-content h2 {
    font-size: 1.75rem !important;
  }

  .carousel-content p {
    font-size: 1rem !important;
  }

  /* Ajustes adicionales para dispositivos muy pequeños */
  .carousel-image {
    max-width: 95% !important;
  }

  /* Hacer el botón de login más pequeño en móviles */
  .v-btn.ma-6 {
    margin: 12px !important;
  }
}
</style>
